import type { ReactNode } from 'react'

export function WorkspacePanel({
  title,
  action,
  onAction,
  children,
  className = '',
  bodyClassName = '',
  dense = false,
  tone = 'default',
}: {
  title: string
  action?: string
  onAction?: () => void
  children: ReactNode
  className?: string
  bodyClassName?: string
  dense?: boolean
  tone?: 'default' | 'gold'
}) {
  const gold = tone === 'gold'
  return (
    <section
      className={`flex min-h-0 flex-col overflow-hidden rounded border border-stone-800/80 bg-[#0a0a0a] ${className}`}
    >
      <header
        className={`flex shrink-0 items-center justify-between border-b px-2.5 ${
          gold
            ? 'border-[#e7cf91]/35 bg-[#b8924f] shadow-[inset_0_1px_0_rgba(255,255,255,0.16)]'
            : 'border-stone-800/80'
        } ${
          dense ? 'py-1' : 'py-1.5'
        }`}
      >
        <h3
          className={`font-mono text-[9px] uppercase tracking-[0.14em] ${
            gold ? 'font-bold text-[#0b0905]' : 'font-semibold text-amber-300/90'
          }`}
        >
          {title}
        </h3>
        {action && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className={`text-[9px] ${
              gold
                ? 'font-semibold text-[#171108]/75 underline-offset-2 hover:text-black hover:underline'
                : 'text-sky-400/90 hover:text-sky-300'
            }`}
          >
            {action}
          </button>
        ) : null}
      </header>
      <div className={`min-h-0 flex-1 overflow-auto ${dense ? 'p-1.5' : 'p-2'} ${bodyClassName}`}>{children}</div>
    </section>
  )
}
